import clsx from 'clsx';
import { use } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  TargetAccumulatorContext,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { isNotDefined } from '@/components/sg-design-system/utils/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import {
  getTargetAccumulatorMarketData,
  selectTargetAccumulatorCurrencyData,
  selectTargetAccumulatorHedgeType,
} from '@/store/targetAccumulator/selectors.ts';

const Delta = () => {
  const { formatNumber } = useIntl();
  const { tileId } = use(TargetAccumulatorContext);
  const { notionalCurrencyIndex, currency } = useAppSelector((state) =>
    selectTargetAccumulatorCurrencyData(state, tileId),
  );
  const marketData = useTargetAccumulatorSelector((targetAccumulator) =>
    getTargetAccumulatorMarketData(targetAccumulator),
  );
  const hedgeType = useAppSelector((state) => selectTargetAccumulatorHedgeType(state, tileId));

  const isExpired = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator.properties.rfs.status === 'EXPIRED',
  );

  if (isNotDefined(notionalCurrencyIndex)) {
    return null;
  }

  const delta = marketData?.delta?.[notionalCurrencyIndex - 1];

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="accumulator.fields.greeks.delta" values={{ hedgeType }} />
      </div>
      {delta && (
        <span className="d-flex flex-column px-1 fs-6" style={{ width: '64%' }} data-e2e="delta">
          {formatNumber(delta, { maximumFractionDigits: 0, minimumFractionDigits: 0 })} {currency}
        </span>
      )}
    </div>
  );
};

export default Delta;
